// 帳號管理
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { i18n } from 'core/i18n';
import SideMenu from 'components/sideMenu';
import Button from 'components/button';
import InputField from 'components/inputField/index';
import Table from 'components/table';
import EditForm from './edit';
import { search, searchAll, clearAgentList } from './action';
import './manage.css';

class ManageIndex extends Component {
  constructor(props) {
    super(props);
    this.createColumns = this.createColumns.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);

    this.state = {
      editStatus: false,
      editAgentId: '',
      searchAgentId: '',
      searchFirstName: '',
      searchLastName: '',
      tablePage: 0,
      rowsPerPage: 10
    };
  }

  componentDidMount() {
    const self = this,
      { props } = self,
      {
        dispatch = () => { }
      } = props;
    dispatch(searchAll());
  }

  componentWillUnmount() {
    const self = this,
      { props } = self,
      { dispatch = () => { } } = props;

    dispatch(clearAgentList());
  }

  handleChangePage(event, newPage) {
    this.setState({
      tablePage: newPage
    });
  };

  handleChangeRowsPerPage(event) {
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      tablePage: 0
    });
  };

  createColumns() {
    const accountColumns = [
      {
        //旅行社帳號
        id: 'agentName',
        label: i18n('agent_id'),
        minWidth: 30,
        align: 'left',
      },
      {
        //名字
        id: 'firstName',
        label: i18n('first_name'),
        minWidth: 40,
        align: 'center',
      },
      {
        //姓氏
        id: 'lastName',
        label: i18n('last_name'),
        minWidth: 40,
        align: 'center',
      },
      {
        //狀態
        id: 'status',
        label: i18n('status'),
        minWidth: 30,
        align: 'center',
      },
      {
        //編輯
        id: 'edit',
        label: i18n('edit'),
        minWidth: 40,
        align: 'center',
        format: value => {
          return value ? (
            <div key={value}>
              <img alt=''
                className='manage-edit-img'
                src={require('assets/images/edit.svg')}
                onClick={() => {
                  this.setState({
                    editStatus: true,
                    editAgentId: value
                  });
                }} />
            </div>
          ) : null
        },
      }];

    return accountColumns;
  }

  render() {
    const self = this,
      {
        state: _state,
        props,
        createColumns,
        handleChangePage,
        handleChangeRowsPerPage
      } = self,
      {
        state,
        mainState,
        dispatch = () => { }
      } = props,
      {
        searchResult
      } = state,
      {
        balanceInfo
      } = mainState,
      {
        editStatus,
        editAgentId,
        searchAgentId,
        searchFirstName,
        searchLastName,
        tablePage,
        rowsPerPage
      } = _state;

    return (
      <div className='manage-container'>
        <div className='area-left'>
          {editStatus && editAgentId ? (
            // 編輯帳號
            <div className='manage-title'>
              <img alt=''
                className='manage-title-back-button'
                src={require('assets/images/back-b.svg')}
                onClick={() => {
                  this.setState({
                    editStatus: false,
                    editAgentId: ''
                  });
                }} />
              {i18n('edit_account')}
            </div>) : (
              // 帳號管理
              <div className='manage-title'>{i18n('manage_account')}</div>)
          }
          <div className='manage-body'>
            {editStatus && editAgentId ? (
              <EditForm
                editAgentId={editAgentId}
                onClose={() => {
                  this.setState({
                    editStatus: false,
                    editAgentId: ''
                  });
                  dispatch(searchAll());
                }}
              />
            ) : (
                <div>
                  <div className='manage-search-panel'>
                    <div className='manage-search-title'>{i18n('search_account')}</div>
                    <div className='manage-search-row'>
                      <InputField
                        placeholder={i18n('agent_id')}
                        onBlurActEvent={(data) => {
                          this.setState({
                            searchAgentId: data
                          });
                        }}
                        value={searchAgentId}
                      />
                      <InputField
                        placeholder={i18n('first_name')}
                        onBlurActEvent={(data) => {
                          this.setState({
                            searchFirstName: data
                          });
                        }}
                        value={searchFirstName}
                      />
                      <InputField
                        placeholder={i18n('last_name')}
                        onBlurActEvent={(data) => {
                          this.setState({
                            searchLastName: data
                          });
                        }}
                        value={searchLastName}
                      />
                      <Button
                        className={'primary-button manage-search-btn'}
                        onClick={() => {
                          let requestData = {
                            agentName: searchAgentId,
                            firstName: searchFirstName,
                            lastName: searchLastName
                          };
                          dispatch(search(requestData));
                        }}
                      >
                        {i18n('search')}
                      </Button>
                    </div>
                  </div>
                  {
                    searchResult.length > 0 ? (
                      <div className='manage-table'>
                        <Table
                          rows={searchResult}
                          columns={createColumns()}
                          tablePage={tablePage}
                          rowsPerPageOptions={[10, 20, 50, 100]}
                          rowsPerPage={rowsPerPage}
                          handleChangePage={handleChangePage}
                          handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </div>
                    ) : null
                  }

                </div>
              )
            }
          </div>

        </div>
        <SideMenu
          balanceInfo={balanceInfo}
        />
      </div>
    );
  }
}

let mapStateToProps = (state) => {
  return {
    state: state.manageReducer,
    mainState: state.mainReducer
  };
};

export default connect(mapStateToProps)(ManageIndex);